export default __webpack_public_path__ + "static/PromptIconTwelve-beea0f213b245a398e7f6c0f402d1fd0.png";